import React from 'react';

export const TranslationsContext = React.createContext({});